export default {
  SET_CARRIER_FEES (state, carrierFees) {
    state.carrierFees = carrierFees
  }
}
